import ky from 'ky';
// const ARTIFICIAL_DELAY_MS = 5000
export const API_VERSION = 'v1';

const client = ky.extend({
  prefixUrl: 'https://api.sommify.ai/',
  credentials: 'include',
  hooks: {
    beforeRequest: [
      (request) => {
        // Do something before every request
        // This is a good place to authorize request if needed
      },
    ],
    afterResponse: [
      (response) => {
        // Do something after every response
        // For example, check status code etc...
      },
    ],
  },
});

export default client;


export const stagingClient = ky.extend({
  prefixUrl: 'https://api.sommify.ai/',
  // credentials: 'include',
});
